var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 19.0001V10.6301C40 9.28009 38.38 8.62009 37.45 9.58009L26.05 20.9501C25.45 21.5501 25.45 22.4801 26.05 23.0801L37.42 34.4501C38.38 35.3801 40 34.7201 40 33.3701V25.0001C51.19 25.0001 60.04 35.2601 57.58 46.8701C56.17 53.6801 50.65 59.1701 43.87 60.5801C33.16 62.8301 23.62 55.4801 22.18 45.5501C21.97 44.1101 20.71 43.0001 19.24 43.0001C17.44 43.0001 16 44.5901 16.24 46.3901C18.1 59.5601 30.64 69.3101 44.83 66.5501C54.19 64.7201 61.72 57.1901 63.55 47.8301C66.52 32.4401 54.82 19.0001 40 19.0001Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.b9353b6cce938cc438360a3a293bc1ef.svg";
export { ForwardRef as ReactComponent };